import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {AuthService, HistoryHelperService, whitelistCharacterValidator, LoginAuthResponseVO, LoginResponseVO} from 'common-domain';
import {PATH_CONSTANTS} from '../app-routing.module';
import {Location} from '@angular/common';
import {gitVersion} from "../../environments/git-version";
import {
  TermsAndPrivacyAcknowledgmentService
} from "./terms-and-privacy-acknowledgment/terms-and-privacy-acknowledgment.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  loginForm: FormGroup;

  successMessage: string;
  errorMessage: string;

  constructor(
    private router: Router,
    private titleService: Title,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private location: Location,
    private historyHelperService: HistoryHelperService,
    private termsAndPrivacyAcknowledgmentService: TermsAndPrivacyAcknowledgmentService) {
  }

  ngOnInit() {
    this.createForm();
    this.getInputData(this.location.getState());
    this.titleService.setTitle('RZM - Login');
  }

  getInputData(data: any) {
    if (data) {
      if (data.success) {
        this.successMessage = data.error;
      } else {
        this.errorMessage = data.error;
      }
    }
  }

  onSubmit() {
    this.successMessage = '';
    this.errorMessage = '';
    const formValue = this.loginForm.value;
    const loginName = formValue.loginName.trim();
    const password = formValue.password;
    const buildInfo = gitVersion.commitLong + '-build-' + gitVersion.buildNumber;
    this.authService.login({loginName, password, buildInfo})
      .subscribe((result: LoginAuthResponseVO|LoginResponseVO) => {
        console.log('result: '+ JSON.stringify(result));
        if (this.hasMfaEnabled(result)) {
          const loginAuthResponseVO = result as LoginAuthResponseVO;
          this.router.navigateByUrl(`/mfa-login-verification-code/${loginAuthResponseVO.token.ref}`);
          return;
        } else {
          this.authService.storeUserDetails(result);
          this.historyHelperService.navigateBack();
        }
      }, error => {
        if (error.status === 419) {
          let url =  PATH_CONSTANTS.SLASH + "changePassword";
          this.router.navigateByUrl(url);
        } else if (error.status >= 500 && error.status < 600) {
          this.errorMessage = 'Please try after some time.';
        } else if (error.status >= 400 && error.status < 500) {
          this.errorMessage = 'Invalid username/password';
        } else if (error.error) {
          this.errorMessage = error.error;
        } else {
          this.errorMessage = 'Invalid username/password';
        }
      });
  }


  private createForm() {
    this.successMessage = '';
    this.errorMessage = '';
    this.loginForm = this.formBuilder.group({
      loginName: new FormControl('', [Validators.required, whitelistCharacterValidator, this.validateUsername()]),
      password: new FormControl('', [Validators.required])
    });
  }

  validateUsername(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const hasAtSymbol = value.indexOf('@') !== -1;
      return hasAtSymbol ? {invalidFormat: true} : null;
    }
  }

  private hasMfaEnabled(result) {
    const addtionalAuth = (result as LoginAuthResponseVO)?.additionalAuth;
    return addtionalAuth && addtionalAuth.toUpperCase() === 'MFA';
  }
}
